<div class="container">
  <mat-drawer-container>
    <mat-drawer #drawer mode="side" position="end" [disableClose]="true" [(opened)]="drawerOpened">
      <custom-objects-quick-view
        *ngIf="drawerOpened"
        [operation]="customObjectOperation"
        [customObjectId]="customObjectId"
        [customObject]="customObject"
        [customObjectValue]="customObjectValue"
        [relatedToType]="relatedToType"
        [relatedToId]="relatedToId"
        [templateId]="templateId"
        [savedView]="savedView()"
        (operationCompleted)="drawerOpened = $event"
      ></custom-objects-quick-view>
    </mat-drawer>

    <mat-drawer-content>
      <!-- Main -->
      <section class="main">
        <!-- Header -->
        <ts-page-header>
          <ng-container page-header-title>
            <section class="list__top__title-wrapper">
              <h5 class="list__top__title">{{ savedView()?.name }}</h5>
            </section>
          </ng-container>
          <ng-container page-header-action-buttons>
            <section class="list__top__action-buttons">
              <ts-button
                color="accent"
                type="stroked"
                icon="ts_file-save"
                [matTooltip]="customObjectValuesCount > 0 ? 'Export as CSV' : 'No data to export'"
                [appAuthorize]="getExportAndShareCustomObjectPermission(customObject.name)"
                denyAction="disable"
                [disabled]="customObjectValuesCount === 0"
                (click)="exportAsCSV()"
              >
                <span class="ml-2">Export</span>
              </ts-button>
              <ts-button
                data-cy="add-custom-object-value"
                [appAuthorize]="getCreateCustomObjectPermission(customObject.name)"
                denyAction="disable"
                color="primary"
                icon="add"
                [matTooltip]="'Add new object'"
                (click)="addCustomObjectValue($event)"
              >
                Add
              </ts-button>
            </section>
          </ng-container>
          <ng-container page-header-action-bar>
            <section class="list__bottom__action-buttons justify-between w-full">
              <div class="flex flex-row items-center gap-2">
                <!-- Search Bar -->
                @if (!hasNestedFiltersOn) {
                  <ts-input
                    [formControl]="searchInputControl"
                    type="text"
                    icon="ts_search"
                    placeholder="Search"
                  ></ts-input>
                }

                <!-- Column Select Panel Button -->
                <ts-button
                  type="stroked"
                  color="accent"
                  icon="visibility"
                  [matTooltip]="'Select columns'"
                  (click)="openFieldDefsPanel()"
                  #fieldDefsPanelOrigin
                >
                  Fields
                  <ng-container *ngIf="displayColumns.length">
                    <ts-badge [value]="displayColumns.length" [type]="'info'"></ts-badge>
                  </ng-container>
                </ts-button>

                <!-- List Filter Button -->
                <ts-button
                  type="stroked"
                  color="accent"
                  icon="ts_filter-list"
                  [tsOverlayTriggerFor]="filtersOverlayBox"
                  [matTooltip]="'Apply filters'"
                >
                  Filter
                  <ng-container *ngIf="filterCounter">
                    <ts-badge [value]="filterCounter" [type]="'info'"></ts-badge>
                  </ng-container>
                </ts-button>
              </div>

              @if (getManagePublicCustomViewsCustomObjectPermission(customObject.name)) {
                <ts-menu [items]="viewManagementOptions" />
              }
            </section>
          </ng-container>
        </ts-page-header>

        <mat-progress-bar mode="indeterminate" [class.hidden]="!isLoading()"></mat-progress-bar>

        <!-- Custom Objects list -->
        <main class="co-values-list">
          <div class="table-wrapper">
            <div class="inline-table-wrapper">
              <ng-container *ngIf="customObjectValues?.length > 0; else emptyList">
                <!-- TS TABLE -->
                @if (newTable) {
                  <ts-table
                    [relatedToRedirectConfig]="relatedToRedirectConfig"
                    [data]="data"
                    [columnDefs]="columnDefs"
                    [rowData]="customObjectValues"
                    [rowSelection]="'single'"
                    [hasActionsColumn]="true"
                    [hasOpenDetailsColumn]="true"
                    [actions]="actions"
                    [autoHeight]="false"
                    (onColumnMove)="onColumnMoved($event)"
                    (cellEditingStopped)="onCellEditingStopped($event)"
                    (openDetails)="handleOpenDetails($event)"
                    (sortChanged)="onSortChanged($event)"
                  ></ts-table>
                } @else {
                  <table
                    mat-table
                    matSort
                    [matSortActive]="sortState?.active"
                    [matSortDisableClear]="true"
                    [matSortDirection]="sortState?.direction"
                    [dataSource]="customObjectValues"
                    class="table-container"
                    [trackBy]="trackByFn"
                    cdkDropList
                    cdkDropListOrientation="horizontal"
                    (cdkDropListDropped)="dropColumns($event)"
                    (matSortChange)="sortChanged($event)"
                  >
                    <ng-container *ngFor="let column of displayColumns">
                      <div class="flex flex-col gt-xs:flex-row">
                        <ng-container *ngIf="lookupField(column) as fieldDef" [matColumnDef]="column">
                          <th
                            class="custom-object-header bg-cool-gray-50 dark:bg-cool-gray-700 pl-2"
                            mat-header-cell
                            mat-sort-header
                            *matHeaderCellDef
                            cdkDrag
                            cdkDragBoundary=".table-container"
                            cdkDragLockAxis="x"
                          >
                            <ng-container *ngIf="column !== 'id'">
                              <div class="drag-handle" cdkDragHandle>
                                <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                              </div>
                            </ng-container>
                            <span class="whitespace-no-wrap"> {{ getObjectName(fieldDef) }} {{ fieldDef.label }} </span>
                          </th>
                          <td
                            data-cy="custom-object-value-list-item-td"
                            mat-cell
                            *matCellDef="let customObjectValue"
                            (click)="fieldDef?.type !== 'record' ? columnClick(customObjectValue, fieldDef) : null"
                          >
                            <app-editable
                              [fieldDef]="fieldDef"
                              [model]="customObjectValue"
                              [data]="data"
                              [readonly]="fieldDef?.type !== 'record'"
                              [showRecordActions]="false"
                            ></app-editable>
                          </td>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>Actions</th>
                      <td mat-cell *matCellDef="let customObjectValue">
                        <button
                          mat-icon-button
                          matTooltip="Edit"
                          (click)="editCustomObjectValue($event, customObjectValue)"
                        >
                          <mat-icon [svgIcon]="'edit'"></mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          matTooltip="Delete"
                          (click)="deleteCustomObjectValue($event, customObjectValue)"
                        >
                          <mat-icon [svgIcon]="'delete'"></mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="customObjectValuesTableColumns; sticky: true"></tr>
                    <tr
                      class="co-values-row"
                      mat-row
                      *matRowDef="let objectItem; columns: customObjectValuesTableColumns"
                    ></tr>
                  </table>
                }

                <!-- Table -->
              </ng-container>
            </div>

            <ng-template #emptyList>
              <div data-cy="custom-object-value-list-empty" class="no-co-values">There are no values!</div>
            </ng-template>
          </div>
        </main>

        <footer class="bottom-actions">
          @if (pageInfo) {
            <ts-paginator
              [pageSize]="pageSize"
              [activePage]="pageInfo.currentPage || 1"
              [totalItems]="pageInfo.filteredCount"
              (pageChanged)="pageChanged($event)"
            ></ts-paginator>
          }
        </footer>
      </section>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<!-- Column Select Panel -->
<ng-template #fieldDefsPanel>
  <app-reporting-builder-field-selector
    [isTimeSeries]="false"
    [fields]="filteredFieldDefs"
    [selectedFields]="customObjectValuesTableColumns"
    [openSelect]="true"
    [groupMode]="true"
    (fieldsChanged)="onFieldsChanged($event)"
    (selectOpenecChanged)="onSelectOpenedChanged($event)"
  ></app-reporting-builder-field-selector>
</ng-template>

<!-- List Filters Panel -->
<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onCloseByBackdropClick()"
>
  <ts-filter
    size="large"
    [fields]="typeFields | async"
    [filters]="filterValueList | async"
    [lookupContract]="lookupService"
    [hasGroups]="true"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  ></ts-filter>
</ts-overlay>
